import { merchantApi } from '@/config/axios'

export interface O2oInviteCodeMerchantPageReqVO {
  pageNo: number
  pageSize: number
  status?: string
}

export interface O2oInviteCodeMerchantRespVO {
  id: number
  code: string
  targetMobile?: string
  status: string
  usedByProviderId?: number
  usedByProviderName?: string
  usedTime?: string
  expireTime?: string
  createTime?: string
}

export interface O2oInviteCodeMerchantCreateReqVO {
  targetMobile: string
}

export function getO2oMerchantInviteCodePage(params: O2oInviteCodeMerchantPageReqVO) {
  return merchantApi.get<{ list: O2oInviteCodeMerchantRespVO[]; total: number }>({
    url: '/merchant-api/o2o/invite-code/page',
    params
  })
}

export function getO2oMerchantInviteCode(id: number) {
  return merchantApi.get<O2oInviteCodeMerchantRespVO>({
    url: '/merchant-api/o2o/invite-code/get',
    params: { id }
  })
}

export function createO2oMerchantInviteCode(data: O2oInviteCodeMerchantCreateReqVO) {
  return merchantApi.post<O2oInviteCodeMerchantRespVO>({
    url: '/merchant-api/o2o/invite-code/create',
    data
  })
}
